/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext } from "react";

import { FooterContext } from "src/context/footerContext";

import { FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";
import { ContactAndSafetyInfoProps } from "./types";

const ContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor, isLogin = false }): JSX.Element => {
  const {changeAccordianVisibility} =  useContext(FooterContext)

  return (
    <>
      <div className={`${alignText} mb-3`}>
        <a type="button" onClick={changeAccordianVisibility}
          className="btn btn-link link-offset-0 link-offset-0-hover link-underline-primary link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline"
        >
          Important Safety Information
        </a>
        <span className={`text-${textColor}`}> | </span>
        <a 
          href="https://www.ferringusa.com/wp-content/uploads/sites/12/2024/04/EuflexxaPI-07-2016.pdf" target="_blank"
          className="btn btn-link link-offset-0 link-offset-0-hover link-underline-primary link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline"
          rel="noreferrer"
        >
          Full Prescribing Information
        </a>
      </div>

      <div className={`${alignText}`} data-tour="sixth-step">
        <p className={`text-${textColor} m-0`}>
          <span className="d-inline-block">Phone: {PHONE_NUMBER}</span>
          &nbsp;|&nbsp;
          <span className="d-inline-block">Fax: {FAX_NUMBER}</span>
        </p>
      </div>
    </>
  );
};

export default ContactAndSafetyInfo;
